import React from 'react';
import { motion } from 'framer-motion';
export function Proof() {
  return <section className="py-24 bg-white" data-id="element-115">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative bg-forest rounded-3xl p-8 md:p-16 text-center overflow-hidden" data-id="element-117">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-118">
            <div className="absolute -top-24 -left-24 w-64 h-64 bg-cream rounded-full blur-3xl" data-id="element-119"></div>
            <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-rust rounded-full blur-3xl" data-id="element-120"></div>
          </div>

          <div className="relative z-10" data-id="element-121">
            <h2 className="text-2xl md:text-4xl font-serif text-cream leading-relaxed font-medium" data-id="element-122">
              "En los próximos 7 días, notarás que la piel de tu perro pasa de
              un rojo intenso a un rosa pálido. El olor a hierro o 'queso' de
              sus patas desaparecerá y, por primera vez en mucho tiempo, ambos
              podrán dormir una noche completa sin interrupciones."
            </h2>
          </div>
        </motion.div>
      </div>
    </section>;
}